var _path, _path2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgQuizWrongIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 1C4.365 1 1 4.365 1 8.5S4.365 16 8.5 16 16 12.635 16 8.5 12.635 1 8.5 1zm0 14.423A6.931 6.931 0 0 1 1.577 8.5 6.931 6.931 0 0 1 8.5 1.577 6.931 6.931 0 0 1 15.423 8.5 6.931 6.931 0 0 1 8.5 15.423z",
    fill: "#837E81",
    stroke: "#837E81"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.77 6.577 11.193 6 8.885 8.308 6.577 6 6 6.577l2.308 2.308L6 11.193l.577.577 2.308-2.308 2.308 2.308.577-.577-2.308-2.308 2.308-2.308z",
    fill: "#837E81",
    stroke: "#837E81",
    strokeWidth: 0.5
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgQuizWrongIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/quiz-wrong-icon.f325dfd5.svg";
export { ForwardRef as ReactComponent };